import { OptionsAsArgument, OptionsRecord } from '@morph-mapper/node-logic';
import { NodeOptionsWrapper, OptionType } from '@morph-mapper/types';
import { GraphId } from '../components/graph-editor/types';

/**
 * Parses the options of a node into a plain object.
 * It removes state variables used by the application and prepares the options to be used as arguments
 * for the logic functions, which transform the options into template code.
 */
export const parseNodeOptions = <T extends OptionsRecord>(
  options: NodeOptionsWrapper<T>,
  resolveGraph: (graphId: GraphId) => unknown
): OptionsAsArgument<T> => {
  return Object.entries(options).reduce((acc, [key, variable]) => {
    if (variable.type === OptionType.Graph) {
      if (!variable.graphId) {
        return {
          ...acc,
          [key]: undefined,
        };
      }
      const graph = resolveGraph(variable.graphId);
      return {
        ...acc,
        [key]: graph,
      };
    }

    if (variable.type === OptionType.Code && typeof variable.value === 'string') {
      try {
        return {
          ...acc,
          [key]: JSON.parse(variable.value),
        };
      } catch {
        return {
          ...acc,
          [key]: undefined,
        };
      }
    }

    return {
      ...acc,
      [key]: variable.value,
    };
  }, {} as OptionsAsArgument<T>);
};
